import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PaymentState } from '../../types';

const initialState: PaymentState = {
  reimbursementRef: '',
  token: '',
  amount: '',
  discountedAmount: '',
  paymentMethod: '',
};

const paymentSlice = createSlice({
  name: 'payment',
  initialState,
  reducers: {
    setReimbursementRef: (state, action: PayloadAction<string>) => {
      state.reimbursementRef = action.payload;
    },
    setToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
    },
    setPaymentAmount: (state, action: PayloadAction<string>) => {
      state.amount = action.payload;
    },
    setPaymentDiscount: (state, action: PayloadAction<string>) => {
      state.discountedAmount = action.payload;
    },
    setPaymentMethod: (state, action: PayloadAction<string>) => {
      state.paymentMethod = action.payload;
    },
    setPaymentData: (state, action: PayloadAction<Partial<PaymentState>>) => {
      return { ...state, ...action.payload };
    },
    clearPayment: () => initialState,
  },
});

export const {
  setReimbursementRef,
  setToken,
  setPaymentAmount,
  setPaymentDiscount,
  setPaymentMethod,
  setPaymentData,
  clearPayment,
} = paymentSlice.actions;

export default paymentSlice.reducer;
